<template>
<div>
  <el-breadcrumb separator=">" class="bread-crumb">
    <el-breadcrumb-item :to="{ path: '/advancepayment/manager' }">进货款管理</el-breadcrumb-item>
    <el-breadcrumb-item>充值记录</el-breadcrumb-item>
  </el-breadcrumb>
  <el-form class="search-form white-box" ref="form" :model="form" :inline="true" label-width="100px">
    <el-form-item label="申请编号">
      <el-input v-model="form.number" placeholder="请输入编号"></el-input>
    </el-form-item>
    <el-form-item label="类型">
      <el-select v-model="form.type" placeholder="请选择类型">
        <el-option label="全部" value="0"></el-option>
        <el-option label="现金充值" value="1"></el-option>
        <el-option label="提现" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="申请状态">
      <el-select v-model="form.status" placeholder="请选择申请状态">
        <el-option label="全部" value="0"></el-option>
        <el-option label="待审核" value="1"></el-option>
        <el-option label="已通过" value="2"></el-option>
        <el-option label="未通过" value="3"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="申请时间">
      <el-date-picker v-model="form.time" type="datetimerange"placeholder="请选择时间"></el-date-picker>
    </el-form-item>
    <el-button type="primary" @click="getRechargeList()">搜索</el-button>
  </el-form>
  <div class="white-box">
    <el-table :data="tableData" class="search-table" v-loading.body="loading">
      <el-table-column
        prop="number"
        label="申请编号"
        width="220">
      </el-table-column>
      <el-table-column
        prop="date"
        label="申请时间"
        width="180">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="充值金额">
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型">
        <!-- <template scope="scope">
          <span v-if="scope.row.type == '1'">现金充值</span>
          <span v-if="scope.row.type == '2'">提现</span>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="voucher"
        label="凭证">
        <template scope="scope">
          <img class="image" :src="scope.row.voucher.split(',')[0]" @click="doCarousel(scope.row.voucher.split(','))"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="申请状态">
        <!-- <template scope="scope">
          <span v-if="scope.row.status == '1'">待审核</span>
          <span v-if="scope.row.status == '2'">已通过</span>
          <span v-if="scope.row.status == '3'">未通过</span>
        </template> -->
      </el-table-column>
      <el-table-column label="未通过原因">
        <template scope="scope">
          <el-popover
            placement="right"
            width="200"
            trigger="hover"
            :content="scope.row.reason">
            <el-button slot="reference" size="small" v-if="scope.row.reason">详情原因</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pageInfo.curPage"
      :page-size="pageInfo.pageSize"
      layout="total, prev, pager, next"
      :total="pageInfo.total">
    </el-pagination>
  </div>
</div>
</template>
<script type="text/javascript">
require('utils/carousel.js')
import moment from 'moment'
import {getRechargeList} from 'api'
export default {
  data () {
    return {
      form: {
        number: '',
        type: '0',
        status: '0',      
        time: []      
      },
      tableData: [],
      pageInfo: {
        pageSize: 20,
        total: 0,
        curPage: 1
      },
      loading: true
    }
  },
  methods: {
    doCarousel (imageList) {  //查看图片
      const _carousel = new Carousel({
        imagesList: imageList,
        indexList: imageList
      })
      _carousel.show()
    },
    handleCurrentChange (page) { // 翻页
      // this.$data.pageInfo.curPage = page
      this.getRechargeList(page)
    },
    getRechargeList (page) {        //获取充值列表
      const _form = this.$data.form 
      const requestParams = Object.assign({}, _form)
      if (requestParams.time.length) {
        requestParams.from = requestParams.time[0] ? moment(requestParams.time[0]).format('YYYY-MM-DD HH:mm:ss') : ''
        requestParams.to = requestParams.time[1] ? moment(requestParams.time[1]).format('YYYY-MM-DD HH:mm:ss') : ''
      } else {
        requestParams.from = ''
        requestParams.to = ''
      }
      requestParams.curPage = page || 1 //this.$data.pageInfo.curPage
      delete requestParams.time

      const _me = this
      _me.$data.loading = true
      getRechargeList({...requestParams}).then( res => {
        _me.$data.loading = false
        if (res.ret == 0) {
          _me.$data.tableData = res.data.list
          _me.$data.pageInfo.total = res.data.totalRecords
          _me.$data.pageInfo.pageSize = res.data.pageSize
          _me.$data.pageInfo.curPage = res.data.curPage
        }
      }).catch( error => {
        _me.$data.loading = false
      })
    }
  },
  created () {
    if(this.$route.query.number) {
      this.$data.form.number = this.$route.query.number
    }
    this.getRechargeList()
  }
}
</script>
<style lang="scss" scoped>
.search-form {
  padding-top: 20px;
  margin-bottom: 5px;
}
.image {
  width: 100%;
}
.el-select {
  width: 170px;
}
</style>


// WEBPACK FOOTER //
// rechargeList.vue?fed1c894